import { ModuleRegistry } from 'ag-grid-community'
import { AllEnterpriseModule } from 'ag-grid-enterprise'
import { AgGridReact } from 'ag-grid-react'

ModuleRegistry.registerModules([AllEnterpriseModule])

AgGridReact.defaultProps = {
  ...(AgGridReact.defaultProps || {}),
  headerHeight: 54,
}
